import { WidgetsSetup } from 'components/posts/detail/layout/widgetsSetup/WidgetsSetupProvider';
import { get, post } from 'api/client';
import config from 'config';
import { createSearchFromParams } from 'utils/url';

export type WidgetsSetupTarget = 'post-preview' | 'post-edit' | 'post-create';

export const WidgetsSetupApi = {
  async get({
    target,
  }: {
    target: WidgetsSetupTarget;
  }): Promise<WidgetsSetup[] | null> {
    const response = await get<WidgetsSetup[] | null>(
      `/me/widget-settings${createSearchFromParams({ target })}`,
      {
        baseURL: config.API_SERVICE_ENDPOINT,
      },
    );
    return response;
  },
  async set({
    target,
    widgetsSetup,
  }: {
    target: string;
    widgetsSetup: WidgetsSetup[] | null;
  }): Promise<WidgetsSetup[]> {
    return post(
      `/me/widget-settings${createSearchFromParams({ target })}`,
      { data: widgetsSetup },
      {
        baseURL: config.API_SERVICE_ENDPOINT,
      },
    );
  },
};
